import angular from 'angular';
import MenuItemDirective from './menu-item.directive';

let MenuItemModule = angular.module('home.menuItem', [])
  .directive('menuItem', MenuItemDirective);

export default MenuItemModule;



/** WEBPACK FOOTER **
 ** ./www/components/home/menu/menu-item/menu-item.js
 **/